import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  ASSET_STATUS_LIST, ASSET_STATUS_DATA, ASSET_STATUS_CREATE,
  ASSET_STATUS_UPDATE, ASSET_STATUS_DELETE,
} from "./actionType";
import {
  assetStatusListSuccess, assetStatusListFailure,
  assetStatusDataSuccess, assetStatusDataFailure,
  assetStatusCreateSuccess, assetStatusCreateFailure,
  assetStatusUpdateSuccess, assetStatusUpdateFailure,
  assetStatusDeleteSuccess, assetStatusDeleteFailure,
} from "./action";
import {
  assetStatusListApi, assetStatusDataApi, assetStatusCreateApi,
  assetStatusUpdateApi, assetStatusDeleteApi,
} from "../../helpers/fakebackend_helper";

function* handleList() {
  try { yield put(assetStatusListSuccess(yield call(assetStatusListApi))); }
  catch (e) { yield put(assetStatusListFailure(e)); }
}
function* handleData({ payload }) {
  try { yield put(assetStatusDataSuccess(yield call(assetStatusDataApi, payload))); }
  catch (e) { yield put(assetStatusDataFailure(e)); }
}
function* handleCreate({ payload }) {
  try { yield put(assetStatusCreateSuccess(yield call(assetStatusCreateApi, payload))); }
  catch (e) { yield put(assetStatusCreateFailure(e)); }
}
function* handleUpdate({ payload }) {
  try { yield put(assetStatusUpdateSuccess(yield call(assetStatusUpdateApi, payload))); }
  catch (e) { yield put(assetStatusUpdateFailure(e)); }
}
function* handleDelete({ payload }) {
  try { yield put(assetStatusDeleteSuccess(yield call(assetStatusDeleteApi, payload))); }
  catch (e) { yield put(assetStatusDeleteFailure(e)); }
}

export default function* AssetStatusSaga() {
  yield all([
    fork(function* () { yield takeEvery(ASSET_STATUS_LIST,   handleList);   }),
    fork(function* () { yield takeEvery(ASSET_STATUS_DATA,   handleData);   }),
    fork(function* () { yield takeEvery(ASSET_STATUS_CREATE, handleCreate); }),
    fork(function* () { yield takeEvery(ASSET_STATUS_UPDATE, handleUpdate); }),
    fork(function* () { yield takeEvery(ASSET_STATUS_DELETE, handleDelete); }),
  ]);
}